import React from 'react';
import {useMatches, useLoaderData} from '@remix-run/react';
import type {
  Product,
  ProductVariant,
} from '@shopify/hydrogen/storefront-api-types';
import clsx from 'clsx';
import {type ShopifyAnalyticsProduct} from '@shopify/hydrogen';
import {Cart, ShopPayButton} from '@shopify/hydrogen-react';

//domains
import type {SanityProductQueryResponse} from 'domains/product';

//components
import {AddToCartButton} from 'components/AddToCartButton';
import ProductDetailsPreorder from './ProductDetailsPreorder';

//data
import {loader} from '~/routes/($lang)/products/$productHandle';

export default function ProductDetailsCTA({
  selectedVariant,
  quantity,
}: {
  selectedVariant: ProductVariant;
  quantity: number;
}) {
  const matches = useMatches();
  const routeData = matches.find(
    (m) => m.id === 'routes/($lang)/products/$productHandle',
  )?.data;

  const {product, analytics, storeDomain} = useLoaderData<typeof loader>();
  const productAnalytics: ShopifyAnalyticsProduct = {
    ...analytics.products[0],
    quantity: 1,
  };
  const productSettings =
    routeData.productSettings as SanityProductQueryResponse['productSettings'];

  const isPreOrder = product?.tags?.includes('pre-order');

  return (
    <div className="mb-[25px] grid gap-2 lg:grid-cols-2 lg:gap-[30px]">
      {!isPreOrder && (
        <div className="">
          <AddToCartButton
            lines={[
              {
                merchandiseId: selectedVariant.id,
                quantity: quantity,
              },
            ]}
            variant="primary"
            data-test="add-to-cart"
            analytics={{
              products: [productAnalytics],
              totalValue: parseFloat(productAnalytics.price),
            }}
            disabled={!selectedVariant?.availableForSale}
            className={clsx([
              'w-full  py-3 text-[20px] font-normal uppercase transition-all duration-200 ease-out',
              !selectedVariant?.availableForSale
                ? 'bg-hk-deep-gray'
                : 'bg-black text-hk-orange hover:bg-hk-orange hover:text-black ',
            ])}
          >
            <span className="pointer-event-none">
              {(!selectedVariant?.availableForSale &&
                productSettings?.product_settings_translations
                  ?.sold_out_label) ??
                'Out of Stock'}
              {(selectedVariant?.availableForSale &&
                productSettings?.product_settings_translations
                  ?.add_to_cart_label) ??
                'Add to cart'}
            </span>
          </AddToCartButton>
        </div>
      )}

      {!isPreOrder && (
        <div
          className={clsx([
            'shop-pay-button--custom w-full text-[20px] font-normal uppercase transition-all duration-200 ease-out text-center relative',
            !selectedVariant?.availableForSale
              ? 'bg-hk-deep-gray'
              : 'bg-hk-orange text-black hover:bg-black hover:text-hk-orange ',
          ])}
        >
          <ShopPayButton
            variantIdsAndQuantities={[
              {id: selectedVariant.id, quantity: quantity},
            ]}
            // The shop's primary domain (checkout.helmetking.com), so the
            // checkout shares the site's .helmetking.com GA cookie.
            storeDomain={storeDomain}
          />
          <span className="absolute top-1/2 left-1/2 -translate-y-1/2 -translate-x-1/2 pointer-events-none">
            {productSettings?.product_settings_translations?.buy_now_label ??
              'Buy now'}
          </span>
        </div>
      )}

      {isPreOrder && (
        <div className="col-span-2">
          <ProductDetailsPreorder productId={product.id} />
        </div>
      )}

      {/* {cartData?.checkoutUrl && (
        <BuyNowButton
          checkoutUrl={cartData?.checkoutUrl}
          lines={[
            {
              merchandiseId: selectedVariant.id,
              quantity: quantity,
            },
          ]}
          variant="primary"
          data-test="add-to-cart"
          analytics={{
            products: [productAnalytics],
            totalValue: parseFloat(productAnalytics.price),
          }}
          disabled={!selectedVariant?.availableForSale}
          className={clsx([
            'w-full py-3 text-[20px] font-normal uppercase transition-all duration-200 ease-out',
            !selectedVariant?.availableForSale
              ? 'bg-hk-deep-gray'
              : 'bg-hk-orange text-black hover:bg-black hover:text-hk-orange ',
          ])}
        >
          {productSettings?.product_settings_translations?.buy_now_label ??
            'Buy now'}
        </BuyNowButton>
      )} */}
    </div>
  );
}
